import { useRef, useState } from "react";
import { Seo } from "@/components/site/Seo";
import { Marquee } from "@/components/site/Marquee";
import { Hero } from "@/components/home/Hero";
import { Bento } from "@/components/home/Bento";
import { CategoryExplorer } from "@/components/home/CategoryExplorer";
import { Stats, Why } from "@/components/home/Why";
import { Guide } from "@/components/home/Guide";
import { Faq } from "@/components/home/Faq";
import { CtaBand } from "@/components/home/CtaBand";
import { BRANDS } from "@/data/site";

export const brandItems = BRANDS.map((b) => (b.primary
  ? <span key={b.name} className="flex items-center gap-3">
      <img src={b.logo} alt={`${b.name} logo – primary brand at Rama Electricals`} className={`w-auto object-contain ${b.name === "L&K" ? "h-11 md:h-14" : "h-6 md:h-8"}`} />
      <span className="font-mono text-[10px] tracking-[0.2em] text-[#39FF14] self-start">PRIMARY</span>
    </span>
  : b.name));

export default function Home() {
  const [active, setActive] = useState("wires");
  const explorerRef = useRef(null);
  const pick = (id) => {
    setActive(id);
    explorerRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  return (
    <>
      <Seo path="/" title="Rama Electricals | Electrical Shop in Goregaon East, Mumbai"
        description="Rama Electricals, Goregaon East, Mumbai: genuine wires, cables, modular switches, BLDC fans, MCBs and smart home products from Legrand, Polycab, L&K, Schneider, KEI and more. GST billing, retail and wholesale rates." />
      <Hero />
      <section className="py-10 border-y border-white/10 bg-[#030712]/60" data-testid="brands-marquee">
        <p className="sr-only">Brands available at Rama Electricals: {BRANDS.map((b) => b.name).join(", ")}</p>
        <Marquee items={brandItems} duration={45} itemClass="font-display text-2xl md:text-3xl text-slate-300" sep="●" />
      </section>
      <Bento onSelect={pick} />
      <CategoryExplorer ref={explorerRef} active={active} onSelect={setActive} />
      <Stats />
      <Why />
      <section className="py-16 overflow-hidden" data-testid="editorial-marquee">
        <Marquee items={["Wires that last", "Power that performs", "Switches with soul", "Safety, certified"]} duration={90}
          itemClass="font-display font-extrabold uppercase text-6xl md:text-[140px] leading-none tracking-tight outline-text" />
      </section>
      <Guide />
      <Faq />
      <CtaBand />
    </>
  );
}
